<ion-content class="ion-padding">
  <usucampeao-documentos-upload [arquivos]="arquivos" [documentoId]="documentoId" [tipo]="tipo"
    (aoRealizarUpload)="adicionarOuAtualizarDocumento($event)"></usucampeao-documentos-upload>
</ion-content>